import { Injectable, OnDestroy, Inject, PLATFORM_ID, InjectionToken } from "@angular/core";
import "rxjs";

import { Subject } from "rxjs";
import { Subscription } from "rxjs/Subscription";
import { TranslateService } from "@ngx-translate/core";
import { NotificationsService } from "angular2-notifications";
import { Title } from "@angular/platform-browser";
import { DOCUMENT, isPlatformBrowser } from '@angular/common';

@Injectable()
export class SharedService implements OnDestroy {
  public translateSubscription: Subscription;
  private readonly documentIsAccessible: boolean;
  constructor(
            // The type `Document` may not be used here. Although a fix is on its way,
    // we will go with `any` for now to support Angular 2.4.x projects.
    // Issue: https://github.com/angular/angular/issues/12631
    // Fix: https://github.com/angular/angular/pull/14894
    @Inject( DOCUMENT ) private document: any,
    // Get the `PLATFORM_ID` so we can check if we're in a browser.
    @Inject( PLATFORM_ID ) private platformId: InjectionToken<Object>,
    private translate: TranslateService,
    private notificationService: NotificationsService,
    private titleService: Title
  ) {
    this.documentIsAccessible = isPlatformBrowser( this.platformId );
  }

  private loading = new Subject<any>();

  public companyTitle: string = "";
  public isExternal;
  public externalLang;
  public externalStyle;



  setProjectTitle(companyName: string){
      if(companyName){
          this.companyTitle = companyName
          //this.titleService.setTitle(this.companyTitle + " " + this.titleService.getTitle());
          this.titleService.setTitle(this.titleService.getTitle());
      }
  }

  getProjectTitle(){

      return this.companyTitle;
  }
  
  loader(data: any) {
    this.loading.next(data);
  }

  isloading() {
    
    return this.loading.asObservable();
  }

  public errorMessage = { status: "", message: "" };
  setErrorMessage(msg) {
    this.errorMessage = msg;
  }

  getErrorMessage() {
    return this.errorMessage;
  }

   /**
   * @param name Cookie name
   * @returns {any}
   */
  getCookie( name: string ): string {
    if ( this.documentIsAccessible && this.check( name ) ) {
      name = encodeURIComponent( name );

      const regExp: RegExp = this.getCookieRegExp( name );
      const result: RegExpExecArray = regExp.exec( this.document.cookie );

      return decodeURIComponent( result[ 1 ] );
    } else {
      return '';
    }
  }

  /**
   * @param name Cookie name
   * @returns {boolean}
   */
  check( name: string ): boolean {
    if ( !this.documentIsAccessible ) {
      return false;
    }

    name = encodeURIComponent( name );

    const regExp: RegExp = this.getCookieRegExp( name );
    const exists: boolean = regExp.test( this.document.cookie );

    return exists;
  }

 /**
   * @param name Cookie name
   * @returns {RegExp}
   */
  private getCookieRegExp( name: string ): RegExp {
    const escapedName: string = name.replace( /([\[\]\{\}\(\)\|\=\;\+\?\,\.\*\^\$])/ig, '\\$1' );

    return new RegExp( '(?:^' + escapedName + '|;\\s*' + escapedName + ')=(.*?)(?:;|$)', 'g' );
  }

  private notificationMessage = [
    { en: "Success", nl: "Succes" },
    { en: "updated successfully", nl: "succesvol geupdatet" },
    {
      en: "Your appointment has been cancelled",
      nl: "Uw afspraak is geannuleerd"
    },
    { en: "Deleted", nl: "verwijderde" },
    { en: "Calendar Updated", nl: "Agenda bijgewerkt" },
    { en: "Calendar added", nl: "Kalender toegevoegd" },
    { en: "Category Created Successfully", nl: "Categorie gemaakt" },
    { en: "Types added succesfully", nl: "Typen slaag toegevoegd" },
    {
      en: "Please add atleast one appointment type",
      nl: "Voeg ten minste één afspraaktype toe"
    },
    { en: "Template has been created", nl: "Template is aangemaakt" },
    { en: "Appointment has been made", nl: "Afspraak is gemaakt" },
    {
      en: "Appointment successfully changed",
      nl: "Afspraak succesvol gewijzigd"
    },
    { en: "Appointment has been canceled", nl: "Afspraak is geannuleerd" },
    {
      en: "Appointment type has been created",
      nl: "Afspraaktype is gewijzigd"
    },
    {
      en: "Appointment type has been removed",
      nl: "Afspraaktype is verwijderd"
    },
    { en: "Appointment types updated", nl: "Afspraaktypes bijgewerkt" },
    { en: "Calendar has been updated", nl: "Kalender is bijgewerkt" },
    { en: "Calendar has been deleted", nl: "Kalender is verwijderd" },
    {
      en: "New calendar has been created",
      nl: "Nieuwe kalender is aangemaakt"
    },
    {
      en: "Scheduling limits saved",
      nl: "Planning beperkingen opgeslagen"
    },
    { en: "Template has been changed", nl: "Template is gewijzigd" },
    { en: "Template removed", nl: "Template verwijderd" },
    { en: "Settings changed", nl: "Instellingen gewijzigd" },
    { en: "Email template changed", nl: "E-mailsjabloon gewijzigd" },
    { en: "Appointment Calendar blocked", nl: "Afspraak Kalender geblokkeerd" },
    {
      en: "Something went wrong, Please try again",
      nl: "Er is iets mis gegaan, probeer het alstublieft nogmaals"
    },
    { en: "Calendar has been cancelled", nl: "Kalender is geannuleerd" },
    { en: "Calendar sync is disabled", nl:"Agenda synchronisatie is uitgeschakeld"}
  ];

  getTranslatedNotification(index) {
    var selectedLanguage = this.translate.currentLang;
    this.translateSubscription = this.translate.onLangChange.subscribe(
      language => {
        selectedLanguage = language.lang;
      }
    );
    if (index !=25) {
      if (selectedLanguage === "en-US") {
        this.notificationService.success(this.notificationMessage[index].en);
      } else if (selectedLanguage === "nl-NL") {
        this.notificationService.success(this.notificationMessage[index].nl);
      }
    } else {
      if (selectedLanguage === "en-US") {
        this.notificationService.error(this.notificationMessage[index].en);
      } else if (selectedLanguage === "nl-NL") {
        this.notificationService.error(this.notificationMessage[index].nl);
      }
    }
  }

  getTranslatedAlertMessage() {
    var selectedLanguage = this.translate.currentLang;
    this.translateSubscription = this.translate.onLangChange.subscribe(
      language => {
        selectedLanguage = language.lang;
      }
    );
    if (selectedLanguage === "en-US") {
      this.notificationService.success(this.notificationMessage[9].en);
    } else if (selectedLanguage === "nl-NL") {
      this.notificationService.success(this.notificationMessage[9].nl);
    }
  }

  ngOnDestroy() {
    this.translateSubscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/shared.service.ts